export default { sha: 'fa5565fee732e994ca05d6bfed186279734b83c9', buildNumber: 'undefined' }
